export default __webpack_public_path__ + "static/media/emissions_measurements_image.b8562de1.png";